<template>
    <div class="length-range">
        <hc-input v-show="showMin" v-model="rangeMin" type="number" />
        <span v-show="showMin" />
        <hc-input
            v-model="rangeMax"
            :style="`${!showMin ? 'width: 100%;' : ''}`"
            type="number"
        />
    </div>
</template>
<script>
export default {
    name: 'LengthRange',
    props: {
        value: {
            type: Array,
            default: () => ([0, 0]),
        },
        showMin: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        rangeMin: {
            get() {
                return this.value[0]
            },
            set(min) {
                const [, max] = this.value
                this.$emit('input', [Number(min), max])
            },
        },
        rangeMax: {
            get() {
                return this.value[1]
            },
            set(max) {
                const [min] = this.value
                this.$emit('input', [min, Number(max)])
            },
        },
    },
}
</script>
<style lang="less" scoped>
.length-range {
    display: flex;
    align-items: center;
    .hc-input {
        width: 60px;
    }
    span {
        width: 12px;
        height: 1px;
        margin: 0 8px;
        background: #ddd;
        display: inline-block;
    }
}
</style>
